import { createSvgIcon } from '@material-ui/core';

// Google Font Icon https://fonts.google.com/icons?selected=Material+Symbols+Outlined:hive:FILL@1;wght@400;GRAD@0;opsz@24&icon.query=hive&icon.style=Outlined&icon.size=24&icon.color=%23e3e3e3
export const HiveIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    fill="currentColor"
  >
    <path d="m651-500-68-120 68-120h134l68 120-68 120H651ZM413-360l-68-120 68-120h134l68 120-68 120H413Zm0-280-68-120 68-120h134l68 120-68 120H413ZM175-500l-68-120 68-120h134l65 120-65 120H175Zm0 280-68-120 68-120h134l65 120-65 120H175ZM417-80l-72-120 68-120h134l68 120-68 120H417Zm234-140-68-120 68-120h134l68 120-68 120H651Z" />
  </svg>,
  'HiveIcon',
);
